import GOApproval from './GOApproval'

export default GOApproval
